export default {
	description: 'This is the only vehicle of this make and model in the Live sale or Buy it now.',
	title: 'You’ve found a rare one',
};
